// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__NdyRe","head":"ProcedureTableInfo_head__kO2aT"};